<template>
  <u-button-group size="xs">
    <u-dropdown
      :items="menuItems"
      :popper="{ placement: 'top-end' }"
    >
      <u-button :icon="COMMON_ICONS.moreVertical" size="xs" variant="solid" color="white"  />
    </u-dropdown>
    <slot />
  </u-button-group>

</template>

<script setup>
  const props = defineProps({
    tag: Object
  });

  const {getContextActions} = useTagActions();

  const actions = getContextActions({tag: props.tag});
  const menuItems = [
    [
      actions.edit,
      actions.share,
      actions.editCover,
      actions.download
    ],
    [actions.delete]
  ];
</script>
